import {Button} from '@wandb/weave/components/Button';
import {
  useClosePeek,
  useWeaveflowRouteContext,
  WeaveflowPeekContext,
} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/context';
import {DeleteModal} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/common/DeleteModal';
import {useObjectDeleteFunc} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/tsDataModelHooks';
import React, {useContext, useState} from 'react';
import {useHistory} from 'react-router-dom';

export const DeleteLeaderboardButton: React.FC<{
  entity: string;
  project: string;
  leaderboardName: string;
  variant?: 'full' | 'icon';
}> = ({entity, project, leaderboardName, variant = 'icon'}) => {
  const closePeek = useClosePeek();
  const {isPeeking} = useContext(WeaveflowPeekContext);
  const {baseRouter} = useWeaveflowRouteContext();
  const history = useHistory();
  const {objectDeleteAllVersions} = useObjectDeleteFunc();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const onSuccess = () => {
    if (isPeeking) {
      closePeek();
    } else {
      history.push(baseRouter.leaderboardsUIUrl(entity, project));
    }
  };

  const onDelete = () => {
    return objectDeleteAllVersions({
      key: {
        entity,
        project,
        objectId: leaderboardName,
        weaveKind: 'object',
        scheme: 'weave',
        versionHash: '',
        path: '',
      },
    });
  };

  return (
    <>
      <Button
        icon="delete"
        variant="ghost"
        onClick={() => setDeleteModalOpen(true)}
        tooltip="Delete leaderboard">
        {variant === 'full' ? 'Delete' : undefined}
      </Button>
      <DeleteModal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        deleteTitleStr={`leaderboard ${leaderboardName}`}
        onDelete={onDelete}
        onSuccess={onSuccess}
      />
    </>
  );
};
